const API_ENDPOINT_URL = process.env.API_ENDPOINT_URL || 'http://35.198.224.88/'
const MASTER_API_KEY = process.env.MASTER_API_KEY
const ADMIN_LOGIN_URL = process.env.ADMIN_LOGIN_URL
const ADMIN_ROLE_ID = process.env.ADMIN_ROLE_ID
const PREFIX_ADMIN_PATH = process.env.PREFIX_ADMIN_PATH || '/'

export {
    API_ENDPOINT_URL,
    MASTER_API_KEY,
    ADMIN_LOGIN_URL,
    ADMIN_ROLE_ID,
    PREFIX_ADMIN_PATH
}